var csrftoken = document.getElementsByName('csrf-token')[0].getAttribute('content');
var base = location.protocol+'//'+location.host;

$(function($){

    /*$("input[name=captcha]").keyup(function(){
        console.log($(this).val());
        $.ajax({
            type: "POST",
            url: "/captcha",
            headers: {'X-CsRF-TOKEN': csrftoken},
            data: {captcha: $(this).val()},
            cache: false,
            contentType: false,
            success: function(data)
            {
                console.log(data);
            }
        });
    });*/

    $('form').submit(function (event) {
        if ($(this).hasClass('submitted')) {
            event.preventDefault();
        }
        else {
            $(this).find(':submit').html('<i class="fa fa-spinner fa-spin"></i>');
            $(this).addClass('submitted');
        }
    });

    $('#choose-file').change(function () {
		var i = $(this).prev('label').clone();
		var file = $('#choose-file')[0].files[0].name;
		$(this).prev('label').text(file);
	});

    $('#department').on('change', function(e){
        e.preventDefault();
        var id_department = $(this).val().split('_');
        id_department = id_department[0];
        $.ajax({
            type: "POST",
            url: base + '/provinces',
            data: {
                _token: $('meta[name="csrf-token"]').attr('content'),
                id: id_department,
            },
            //dataType: 'json',
            success: function success(response) {
                if (response.length > 0) {
                    var options = '<option value="" disabled selected>Provincia</option>';

                    for (var r = 0; r < response.length; r++) {
                        options += '<option value="' + response[r].id + '_' + response[r].name + '">' + response[r].name + '</option>';
                    }

                    $('#province').html(options);
                    $('#district').html('<option value="" disabled selected>Distrito</option>');
                }
            },
            beforeSend: function beforeSend() {
                var option = '<option value="" disabled selected>Cargando ...</option>';
                $('#province').html(option);
                $('#district').html(option);
            },
            error: function error(_error3, e) {
                console.log(_error3);
                console.log(e);
            }
        });
    });

    $('#province').on('change', function(e){
        e.preventDefault();
        var id_province = $(this).val().split('_');
        id_province = id_province[0];
        $.ajax({
            type: "POST",
            url: base + '/districts',
            data: {
                _token: $('meta[name="csrf-token"]').attr('content'),
                id: id_province,
            },
            //dataType: 'json',
            success: function success(response) {
                if (response.length > 0) {
                    var options = '<option value="" disabled selected>Distrito</option>';

                    for (var r = 0; r < response.length; r++) {
                        options += '<option value="' + response[r].name + '">' + response[r].name + '</option>';
                    }

                    $('#district').html(options);
                }
            },
            beforeSend: function beforeSend() {
                var option = '<option value="" disabled selected>Cargando ...</option>';
                $('#district').html(option);
            },
            error: function error(_error3, e) {
                console.log(_error3);
                console.log(e);
            }
        });
    });

    $('#btn-toggle').click(function(e){
        e.preventDefault();
        $(".sec7").slideToggle(1000);
    });

    $("input[name=telephone]").bind("change keyup input", function() {
        var position = this.selectionStart - 1;
        var fixed = this.value.replace(/[^0-9]/g, "");
    
        if (this.value !== fixed) {
          this.value = fixed;
          this.selectionStart = position;
          this.selectionEnd = position;
        }
    });

    $('#carousel-servicios').owlCarousel({
        loop: true,
        startPosition: 1,
        center: true,
        items: 3,
        margin: 18,
        autoplay: true,
        dots:true,
        autoplayTimeout: 3000,
        smartSpeed: 450,
        responsive: {
            0: {
            items: 1,
            nav: true,
            },
            768: {
            items: 1,
            nav: true,
            },
            1000: {
            items: 3,
            nav: true,
            }
        }
    });

    $('#carousel-mision').owlCarousel({
        loop: true,
        startPosition: 1,
        center: true,
        items: 3,
        margin: 18,
        autoplay: false,
        dots:true,
        autoplayTimeout: 3000,
        smartSpeed: 450,
        responsive: {
            0: {
            items: 1,
            nav: true,
            },
            768: {
            items: 1,
            nav: true,
            },
            1000: {
            items: 3,
            nav: true,
            }
        }
    });

    $('#carousel-testimonios').owlCarousel({
        loop: true,
        startPosition: 1,
        center: true,
        items: 3,
        margin: 25,
        autoplay: false,
        dots:true,
        autoplayTimeout: 3000,
        smartSpeed: 450,
        responsive: {
            0: {
            items: 1,
            nav: true,
            },
            768: {
            items: 1,
            nav: true,
            },
            1000: {
            items: 3,
            nav: true,
            }
        }
    });

    $('#carousel-servicios-mobile').owlCarousel({
        loop: true,
        center: true,
        items: 3,
        margin: 25,
        autoplay: true,
        dots:true,
        autoplayTimeout: 3000,
        smartSpeed: 450,
        responsive: {
            0: {
            items: 1,
            nav: true,
            },
            768: {
            items: 1,
            nav: true,
            },
            1000: {
            items: 3,
            nav: true,
            }
        }
    });

    $('#carousel-clientes').owlCarousel({
        loop: true,
        startPosition: 1,
        center: true,
        items: 3,
        margin: 8,
        autoplay: true,
        dots:true,
        autoplayTimeout: 3000,
        smartSpeed: 450,
        responsive: {
            0: {
            items: 3,
            nav: true,
            },
            768: {
            items: 3,
            nav: true,
            },
            1000: {
            items: 6,
            nav: true,
            }
        }
    });

    $('.burgergg').on('click',function(){
        if($('.nav-mobile').hasClass('nav-mobile-active'))
        {
            $('.nav-mobile').removeClass('nav-mobile-active');
        }else
        {
            $('.nav-mobile').addClass('nav-mobile-active');
        }
        if($('.linea1').hasClass('toggle1')){$('.linea1').removeClass('toggle1');}else{$('.linea1').addClass('toggle1');}
        if($('.linea2').hasClass('toggle2')){$('.linea2').removeClass('toggle2');}else{$('.linea2').addClass('toggle2');}
        if($('.linea3').hasClass('toggle3')){$('.linea3').removeClass('toggle3');}else{$('.linea3').addClass('toggle3');}
    });

    $('.btn-cerrar').on('click',function(){
        if($('.nav-mobile').hasClass('nav-mobile-active'))
        {
            $('.nav-mobile').removeClass('nav-mobile-active');
        }else
        {
            $('.nav-mobile').addClass('nav-mobile-active');
        }
        if($('.linea1').hasClass('toggle1')){$('.linea1').removeClass('toggle1');}else{$('.linea1').addClass('toggle1');}
        if($('.linea2').hasClass('toggle2')){$('.linea2').removeClass('toggle2');}else{$('.linea2').addClass('toggle2');}
        if($('.linea3').hasClass('toggle3')){$('.linea3').removeClass('toggle3');}else{$('.linea3').addClass('toggle3');}
    });

})